<script>
import Spinner from "@/components/ui/Spinner";

export default {
  name: "SpinnerModal",
  components: {
    Spinner,
  },

  props: {
    text: {
      type: String,
    },
  },
};
</script>

<template lang="pug">
  .modal
    .spinner-container
      h1 {{ text }}
      spinner
</template>

<style lang="scss" scoped>
.spinner-container {
  display: flex;
  gap: 50px;
  flex-direction: column;
  border-radius: 20px;
  background-color: $white;
  display: flex;
  height: 100%;
  justify-content: center;
  align-items: center;
}
</style>
